import { render, staticRenderFns } from "./not-found.component.vue?vue&type=template&id=e0d04fba"
var script = {}
import style0 from "./not-found.component.vue?vue&type=style&index=0&id=e0d04fba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports